import { Subject } from 'rxjs';

export let sideMenuActiveObserver = new Subject<boolean>();

export let showWorkspaceTabObserver = new Subject<void>();

export let styleChangedObserver = new Subject<string>();
